import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    diffuseurs: []
  },
  getters: {
    getDiffuseurs: (state) => state.diffuseurs,
    getDiffuseurByName: (state) => (name) => {
      return Object.keys(state.diffuseurs).find(key => state.diffuseurs[key] === name)
    },
    getDiffuseurById: (state) => (id) => {
      return state.diffuseurs[id]
    }
  },
  mutations: {
    setDiffuseurs (state, diffuseurs) {
      state.diffuseurs = diffuseurs
    }
  },
  actions: {
    loadDiffuseurs (context) {
      // const url = '/diffuseurs'
      const url = '/v2/diffuseurs'
      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then((response) => {
          context.commit('setDiffuseurs', response.data)
        })
        .catch((error) => console.log(error))
    }
  }
}
